import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import UpdatedToast from '@/components/toasts/UpdatedToast';
import ErrorToast from '@/components/toasts/ErrorToast';
import { responseError } from '@/utils/errors';
import showToast from '@/utils/toasts';
import TasksCompleteToast from '../components/TasksCompleteToast';
import actions from '../constants';

export function* updateToast({ code, name, silent }) {
  if (!silent) {
    yield call(showToast, <UpdatedToast code={code} name={name} />);
  }
}

export function* updateRequestTaskErrorToast(action) {
  if (!action.silent) {
    yield call(
      showToast,
      <ErrorToast operation="actions.update" name={action.name} error={responseError(action).message} />,
    );
  }
}

export function* completeRequestTasksToast({ items }) {
  yield call(showToast, <TasksCompleteToast items={items} />);
}

export default function* requestTasksToasts() {
  yield takeEvery([actions.SHOW_UPDATE_REQUEST_TASK_SUCCESS, actions.SHOW_MANAGE_REQUEST_TASK_SUCCESS], updateToast);
  yield takeEvery(actions.COMPLETE_REQUEST_TASKS_SUCCESS, completeRequestTasksToast);
  yield takeEvery(actions.SHOW_UPDATE_REQUEST_TASK_ERROR, updateRequestTaskErrorToast);
}
